var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsername(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2191 19.3214C13.3698 20.1346 11.213 20.2521 9.1739 19.4819C5.04177 17.9211 2.95731 13.306 4.51812 9.1739C6.07894 5.04177 10.694 2.95731 14.8261 4.51812C18.6939 5.9791 20.7677 10.1161 19.7371 14.0282C19.5996 14.5498 19.2166 14.9629 18.7372 15.2102V15.2102C17.2852 15.9591 15.5556 14.9051 15.5556 13.2714V8.48379M15.5556 12C15.5556 13.9637 13.9637 15.5556 12 15.5556C10.0363 15.5556 8.44444 13.9637 8.44444 12C8.44444 10.0363 10.0363 8.44444 12 8.44444C13.9637 8.44444 15.5556 10.0363 15.5556 12Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsername);
export default __webpack_public_path__ + "static/media/username.3712363ac639cb59dcb844419fd8377f.svg";
export { ForwardRef as ReactComponent };